module.exports = __webpack_public_path__ + "img/logo.f124d905.png";